import { NavFpMicroController, NavFpMicroDirective } from './components/nav-fp-micro/nav-fp-micro';
import {
  NavSurveyHomeMicroController,
  NavSurveyHomeMicroDirective
} from './components/nav-survey-home-micro/nav-survey-home-micro';
import { NavHostController, NavHostDirective } from './components/nav-host/nav-host';
import { NavCalendarController, NavCalendarDirective } from './components/nav-calendar/nav-calendar';
import { HostingService, initializeHosting } from './services/hosting_service';
import { MicroRoutes } from './services/micro_routes';
import { HostRoutes } from './host_routes';

angular
  .module('host', [])
  // /my/fp
  //
  .controller('NavFpMicroController', NavFpMicroController)
  .directive('navFpMicro', () => NavFpMicroDirective)
  // /my/survey_home
  //
  .controller('NavSurveyHomeMicroController', NavSurveyHomeMicroController)
  .directive('navSurveyHomeMicro', () => NavSurveyHomeMicroDirective)
  // /my/host
  //
  .controller('NavHostController', NavHostController)
  .directive('navHost', () => NavHostDirective)
  // /my/calendar
  //
  .controller('NavCalendarController', NavCalendarController)
  .directive('navCalendar', () => NavCalendarDirective)
  // host (fi-hosting)
  //
  .service('ngHostingService', HostingService)
  .constant('ngMicroRoutes', MicroRoutes)
  .run(initializeHosting)
  .config(HostRoutes);



// WEBPACK FOOTER //
// ./app/lib/host/host_module.ts